import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { UtilsService } from "src/app/services/utils.service";

/**
 * Garde basique d'authentification.
 *
 * <p>Bloque l'accès à toute route protégée si aucun token n'est présent
 * en localStorage. Sans ce guard, un utilisateur déconnecté peut taper
 * directement {@code /administration/...} dans la barre d'adresse et
 * voir la coquille (la sidebar et le layout sont rendus, même si les
 * appels HTTP échoueront en 401 derrière).
 *
 * <p>À appliquer sur la route racine {@code administration} dans
 * {@code app.routing.ts}. Les guards plus fins (super-admin, system-admin,
 * institution-admin) restent posés au niveau des sous-routes pour
 * différencier les rôles.
 *
 * <p>Si pas connecté → redirige vers {@code /auth/sign-in}.
 */
export const authGuard: CanActivateFn = () => {
  const utils = inject(UtilsService);
  const router = inject(Router);

  if (!utils.hasToken()) {
    router.navigate(["/auth/sign-in"]);
    return false;
  }
  return true;
};
